export default "__VITE_ASSET__SkpINfAS__"